import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import TotalIncomeMonthlyPageUI from './TotalIncomeMonthlyPageUI.js'

class TotalIncomeMonthlyPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountIncomeList: null,
      checked: false,
      response: null,
    }
  }

  render() {
    return (
      <TotalIncomeMonthlyPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountIncomeList={this.state.accountIncomeList}
        checked={this.state.checked}
        onShowDetailsChange={this.onShowDetailsChange}
        response={this.state.response}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }


  componentDidMount() {
    let context = this.props.context
    let cacheManager = new CacheManager({
      resource: `dummy`,
      cacheKey: CacheKeys.AccountRepaymentsChecked()
    })
    let checkedObj = cacheManager.getObjectFromCache()
    if (checkedObj)
      this.setState({ checked: checkedObj.checked })
    this.getIncomeMonthly(context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.year == prevProps.match.params.year && this.props.match.params.month == prevProps.match.params.month)
      return
    this.getIncomeMonthly(this.props.context)
  }

  getIncomeMonthly(context) {
    console.log(this.props.match.params.year, this.props.match.params.month)
    console.log(CacheKeys.MonthlyIncome(this.props.match.params.year, this.props.match.params.month))

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/income/yearMonth`,
      cacheKey: CacheKeys.MonthlyIncome(this.props.match.params.year, this.props.match.params.month),
      callback: this.getIncomeMonthlyCallback,
      ttlInSecs: 60
    })
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getIncomeMonthlyCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountIncomeList: response.accountIncomeList,
      response: response
    })
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AllRepayments(this.props.match.params.year, this.props.match.params.month))
    // CacheManager.removeObject(CacheKeys.IncomeMonthly(this.state.yearMonth))
    this.setState({ accountIncomeList: null, errorList: null }, () => {
      this.getIncomeMonthly(this.props.context)
    })
  }
}

export default withRouter(TotalIncomeMonthlyPageSF)
